import React, {Component} from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardMedia from "@mui/material/CardMedia";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {CircularProgress, Container, List, ListItem, ListItemButton, ListItemText, Pagination} from "@mui/material";
import {BottomSheet} from "../../../src/bottom_sheet_mui/src/components/BottomSheet";
import * as PropTypes from "prop-types";
import * as Icons from '@mui/icons-material';
import ListItemIcon from "@mui/material/ListItemIcon";
import GifLoader from "../../GifLoader";


ListItemIcon.propTypes = {children: PropTypes.node};
export default class FavoriteFragment extends Component {

    componentDidMount() {}

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            page: 1,
            data: [],
            error: false,
            menuFav: false,
            menuID: ''
        };
        window.favoritePage = this;
        this.prepare();
    }
    checkTheme = () => {
        if (localStorage.getItem("theme") !== null) {
            return localStorage.getItem("theme").includes("true");
        } else {
            return true
        }
    }
    getAllFav = () => {
        let list = [], keys = Object.keys(localStorage), i = keys.length;
        while ( i-- ) {
            if (keys[i].includes("INFO_")) {
                list.push(JSON.parse(localStorage.getItem(keys[i])));
            }
        }
        return list;
    }
    prepare = () => {
        setTimeout(() => {
            let lists = this.getAllFav();
            this.setState({
                data: lists.array_chunk(50),
                page: 1,
                loading: false
            });
            this.updateAccount();
        },100);
    }
    showMenu = (item) => {
        this.setState({
            menuFav: true,
            menuID: item.id
        });
    }
    restartPage = () => {
        this.setState({
            loading: true,
            error: false
        });
        setTimeout(()=> {
            this.prepare();
        },500);
    }
    animePageChanged = (event, value) => {
        this.setState({page: value});
    }
    closeMenuFav = () => {
        this.setState({menuFav: false});
    }
    showAnime = () => {
        window.main.goLink("/info?id="+this.state.menuID);
    }
    deleteAnime = () => {
        localStorage.removeItem("INFO_"+this.state.menuID);
        let lists = this.getAllFav();
        this.setState({
            data: lists.array_chunk(50),
            page: 1,
            loading: false,
            menuFav: false
        });
        this.updateAccount();
    }
    getAccount = () => {
        if (localStorage.getItem("logged") !== null) {
            this.setState({
                page: 1,
                loading: true
            });
            let data = JSON.parse(localStorage.getItem("loggedData"));
            fetch("https://app.sanime.net/function/h10.php?page=getFav&id="+data.id).then((response) => {
                response.text().then((list) => {
                    const lists = JSON.parse(list);
                    for (let i = 0; i < lists.length; i++) {
                        let title = lists[i].title;
                        let image = lists[i].image;
                        let id = lists[i].id;
                        let infoDat = {
                            "title": title,
                            "image": image,
                            "id": id
                        }
                        localStorage.setItem("INFO_"+id,JSON.stringify(infoDat));
                    }
                    let listss = this.getAllFav();
                    this.setState({
                        data: listss.array_chunk(50),
                        page: 1,
                        loading: false
                    });
                })
            }).catch(() => {
                let lists = this.getAllFav();
                this.setState({
                    data: lists.array_chunk(50),
                    page: 1,
                    loading: false
                });
            })
        } else {
            window.main.showMessage("قم بتسجيل الدخول لأستعادة أنمياتك القديمة","تنبيه","حسنا","",true);
        }
    }
    updateAccount = () => {
        if (localStorage.getItem("logged") !== null) {
            let data = JSON.parse(localStorage.getItem("loggedData"));
            let lists = this.getAllFav();
            if (lists.length > 0) {
                let params = new URLSearchParams();
                params.append("email",data.email);
                params.append("password",data.password);
                params.append("item",btoa(unescape(encodeURIComponent(JSON.stringify(lists)))));
                fetch('https://app.sanime.net/function/h10.php?page=updateFav', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: params
                }).then((response) => {
                    response.text().then(() => {});
                });
            }
        }
    }

    render() {
        if (this.state.loading) {
            return <Container style={{placeContent: 'center',textAlign: 'center',height: '100%'}}>
                <div style={{height: '350px'}} />
                <GifLoader size={55} />
                <div/>
            </Container>
        } else {
            return <Box>
                {this.state.data.length === 0 ? <Box style={{marginBottom: '7px'}} height={'100%'}>
                    <List>
                        <ListItem style={{padding:"0px", placeContent: "center"}}>
                            <Typography style={{fontFamily: "'Changa'"}}>
                                قائمة المفضلة خالية
                            </Typography>
                        </ListItem>
                    </List>
                </Box> : <Box style={{marginTop: '0px',marginBottom: '0px'}} height={'100%'}>
                    <Grid style={{paddingBottom: '6px'}} sx={{ flexGrow: 1 }} container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container justifyContent="center" spacing={1.4}>
                                {this.state.data[this.state.page - 1].map(r =>
                                    <Grid key={r.id} item>
                                        <Card sx={{ width: window.main.if360() ? 105 : 120 }} onClick={this.showMenu.bind(this,r)} >
                                            <CardActionArea>
                                                <CardMedia
                                                    component="img"
                                                    height="185"
                                                    image={r.image}
                                                    alt={r.title}
                                                />
                                                <Divider sx={{height: 1.2}} color={'#00b2ff'}/>
                                                <Stack style={{paddingRight: '4px',paddingLeft: '4px',paddingBottom: '3px',paddingTop: '1px'}} spacing={0}>
                                                    <Typography style={{textOverflow: "ellipsis",overflow: "hidden",whiteSpace: "nowrap",fontSize: '14px'}}>{r.title}</Typography>
                                                </Stack>
                                            </CardActionArea>
                                        </Card>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                    {
                        this.state.data.length === 1 ? <Box/> :  this.state.data.length === 0 ? <Box/> : <Pagination className={"centerPage"} style={{margin: '4px'}} siblingCount={0} size="large" color={"primary"} page={this.state.page} onChange={this.animePageChanged} count={this.state.data.length} variant="outlined" shape="rounded" />
                    }
                    <BottomSheet contentStyle={this.checkTheme() ? {backgroundColor: "#252e39"} : {backgroundColor: "white"}} onRequestClose={() => this.closeMenuFav()} open={this.state.menuFav}>
                        <List>
                            <ListItem disablePadding>
                                <ListItemButton onClick={this.showAnime}>
                                    <ListItemIcon>
                                        <Icons.InfoOutlined />
                                    </ListItemIcon>
                                    <ListItemText primary="صفحة الأنمي" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton  onClick={this.deleteAnime}>
                                    <ListItemIcon>
                                        <Icons.Delete />
                                    </ListItemIcon>
                                    <ListItemText primary="حذف" />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </BottomSheet>
                </Box>}
            </Box>
        }
    }
}